






















import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import moment from 'moment'
import { Setting } from '@/setting'

@Component
export default class SelfCheckProgressCell extends Vue {
  @Prop() selfcheck!: ISelfCheckAnswer
  @Prop() sc0wIsOpened?: boolean;

  get progressIndex (): number {
    return Setting.SelfCheckIndexToWeek(this.selfcheck.answerIndex)
  }

  get answeredAll (): boolean {
    return Object.values(this.selfcheck.survey).every(v => {
      return !!v && (v as any).answeredAt !== null
    })
  }

  get dateYear () {
    if (!this.selfcheck.survey) return ''

    if (!this.answeredAll && this.selfcheck.canAnswerAt != null) {
      const canAnswerAt = new Date(this.selfcheck.canAnswerAt)
      const now = new Date()
      if (now < canAnswerAt) {
        return moment(canAnswerAt).format('YYYY')
      }

      const status = this.getClass(this.selfcheck)
      const max = new Date(canAnswerAt)
      max.setDate(max.getDate() + Setting.SELFCHECK_DEADLINE_DAYS[this.selfcheck.answerIndex])
      const targets = ['started', 'notstarted', 'alert-started', 'alert-notstarted']
      return targets.includes(status) ? moment(max).format('YYYY') : ''
    }

    const survey = this.firstSurvey
    return survey.answeredAt !== null
      ? moment(survey.answeredAt).format('YYYY')
      : ''
  }

  get dateMonthAndDate () {
    if (!this.selfcheck.survey) return ''

    if (!this.answeredAll && this.selfcheck.canAnswerAt != null) {
      const canAnswerAt = new Date(this.selfcheck.canAnswerAt)
      const now = new Date()
      if (now < canAnswerAt) {
        return moment(canAnswerAt).format('MM/DD')
      }

      const status = this.getClass(this.selfcheck)
      const max = new Date(canAnswerAt)
      max.setDate(max.getDate() + Setting.SELFCHECK_DEADLINE_DAYS[this.selfcheck.answerIndex])
      const targets = ['started', 'notstarted', 'alert-started', 'alert-notstarted']
      return targets.includes(status) ? moment(max).format('MM/DD') : ''
    }

    const survey = this.firstSurvey
    return survey.answeredAt !== null
      ? moment(survey.answeredAt).format('MM/DD')
      : ''
  }

  get firstSurvey () {
    const key = Object.keys(this.selfcheck.survey)[0]
    return this.selfcheck.survey[key]
  }

  getClass (selfcheckAnswer: ISelfCheckAnswer, today: Date = new Date()) {
    if (selfcheckAnswer === undefined) {
      return 'not-exists'
    }
    const answeredCount = Object.entries(selfcheckAnswer.survey).reduce((h, [k, v]) => {
      return v && (v as any).answeredAt !== null ? h + 1 : h
    }, 0)

    // すべて回答済みの場合
    if (answeredCount === Object.entries(selfcheckAnswer.survey).length) {
      return 'finished'
    }

    // 以下回答していない場合の処理
    if (selfcheckAnswer.canAnswerAt === null) {
      return 'locked'
    }

    const canAnswerAt = new Date(selfcheckAnswer.canAnswerAt)
    const diff = moment.duration(moment(today).diff(moment(canAnswerAt)))
    if (diff.asDays() < 0) {
      return 'before'
    }
    const duration = Setting.SELFCHECK_DEADLINE_DAYS[selfcheckAnswer.answerIndex]
    const alertDuration = duration - Setting.SELFCHECK_ALERT_TERM
    if (selfcheckAnswer.answerIndex === 0) {
      if (this.sc0wIsOpened) {
        return 'notstarted'
      } else {
        return 'locked'
      }
    } else if (diff.asDays() < alertDuration) {
      if (answeredCount > 0) {
        return 'started'
      } else {
        return 'notstarted'
      }
    } else if (diff.asDays() < duration) {
      if (answeredCount > 0) {
        return 'alert-started'
      } else {
        return 'alert-notstarted'
      }
    } else {
      if (answeredCount > 0) {
        return 'partial-answered'
      }
      return 'deadline-overed'
    }
  }

  getDateType (selfcheckAnswer: ISelfCheckAnswer) {
    if (this.answeredAll) {
      return 'date-type-answered'
    }

    if (selfcheckAnswer.canAnswerAt) {
      const index = selfcheckAnswer.answerIndex
      const duration = Setting.SELFCHECK_DEADLINE_DAYS[index] * 1000 * 60 * 60 * 24
      const alertDuration = duration - (Setting.SELFCHECK_ALERT_TERM * 1000 * 60 * 60 * 24)
      const now = new Date().getTime()
      const canAnswerAt = new Date(selfcheckAnswer.canAnswerAt).getTime()
      if (canAnswerAt < now) {
        if (canAnswerAt + alertDuration < now) {
          return 'date-type-answer-alert-duration'
        } else if (now < canAnswerAt + duration) {
          return 'date-type-can-answer'
        } else {
          return 'date-type-none'
        }
      } else {
        return 'date-type-before'
      }
    }
    return 'date-type-none'
  }
}

export interface ISelfCheckAnswer {
  canAnswerAt: Date | null
  answerIndex: number
  alert: boolean
  survey: any
}

